import MainPageFourthScreenCommon from "./MainPageFourthScreenCommon";
import gsap from "../../../../helpers/gsapInstance";

export default class MainPageFourthScreenMobile extends MainPageFourthScreenCommon {
    public readonly $holder: JQuery;

    constructor($holder: JQuery) {
        super($holder);

        this.$holder = $holder;

    }

    /**
     * Инициировать все события, связанные со скроллром и анимацией для 4 экрана на мобилке и планшете
     * @public
     */
    public initScreenScrollingAnimations(): void {
        this.initSlideHeadingTitleScrollingAnimation();
        this.setDefaultCirclesValues();
        this.initSlideCirclesScrollingAnimation();
    }

    /**
     * Инициализация анимации для сдвига заголовка снизу-вверх
     * @private
     */
    private initSlideHeadingTitleScrollingAnimation(): void {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: this.$screen,
                start: "top center",
            },
        });

        tl.fromTo(this.$title,
            {
                transform: 'translateY(30%)',
                opacity: 0,
            },
            {
                transform: 'translateY(0%)',
                opacity: 1,
                duration: 0.6
            },
        )
    }

    /**
     * Инициализация анимации для сдвига кругов снизу-вверх
     * @private
     */
    private initSlideCirclesScrollingAnimation(): void {
        let tl: gsap.core.Timeline;

        if (this.isMobilePhone()) {
            tl = this.getSlideCircleAnimationInitiationTimelineForTablet();
        } else {
            tl = this.getSlideCircleAnimationInitiationTimelineForMobile();
        }

        tl.fromTo(this.$roundsBlock,
            {
                transform: 'translateY(30%)',
                opacity: 0,
            },
            {
                transform: 'translateY(0%)',
                opacity: 1,
                duration: 0.6,
                onComplete: () => this.setStartedCirclesAnimation()
            },
        )
    }

    /**
     * Инициализация получения таймлайна для анимации по сдвига кругов снизу-вверх (планшет)
     * @private
     */
    private getSlideCircleAnimationInitiationTimelineForTablet(): gsap.core.Timeline {
        return gsap.timeline({
            scrollTrigger: {
                trigger: this.$title,
                start: "top center"
            },
        });
    }

    /**
     * Инициализация получения таймлайна для анимации по сдвига кругов снизу-вверх (мобильный телефон)
     * @private
     */
    private getSlideCircleAnimationInitiationTimelineForMobile(): gsap.core.Timeline {
        return gsap.timeline({
            scrollTrigger: {
                trigger: this.$screenContainer,
                start: "25% center"
            },
        });
    }
}
